import { toast } from "@/components/ui/use-toast";
import { gql } from "@/gql/__generated__";
import { AppDeploymentStatus } from "@/gql/__generated__/graphql";
import { useSubscription } from "@apollo/client";

const APP_DEPLOY_EVENTS = gql(`
    subscription APP_DEPLOY_EVENTS($deployVersionID:ID!){
        appDeployEvents(appDeploymentVersionID: $deployVersionID) {
            __typename
            ... on AppBuildMessageEvent {
            message
            }
            ... on AppDeploymentStatusEvent {
            status
            }
            ... on AppBuildErrorEvent {
            message
            }
        }
    }
`);

export const useSubscribeToStatusUpdates = (
  deployVersionID: string,
  onStatusChange: (status: AppDeploymentStatus) => void
) => {
  return useSubscription(APP_DEPLOY_EVENTS, {
    variables: { deployVersionID },
    skip: !deployVersionID,
    fetchPolicy: "no-cache",
    onData: (res) => {
      const { data, error } = res.data;

      if (data?.appDeployEvents?.__typename === "AppDeploymentStatusEvent") {
        if (data.appDeployEvents.status)
          onStatusChange(data.appDeployEvents.status);
        if (data.appDeployEvents.status === AppDeploymentStatus.Running)
          toast({
            title: "Deployment done",
            description: "Your app was successfully deployed!"
          });
      }
      if (error) {
        toast({
          title: "Deployment failed",
          description:
            "Failed to deploy app, please try again or report the issue."
        });
        console.error("Error in subscription:", error);
      }
    }
  });
};
